import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @devextreme
import { Popover } from 'devextreme-react/popover';
// utils
import { timezones } from '../../../utils/format';
// styles
import { MoreButton } from '../../../styles';

// ----------------------------------------------------------------------

interface Props {
  row: {
    displayNameId: string;
    category: string;
    waterTemperature: string;
    waterTemperatureUnit: number;
    modifiedAt: string;
    createdAt: string;
  };
  setDialog: React.Dispatch<any>;
};

// ----------------------------------------------------------------------

export default function TableRow({ row, setDialog }: Props){
  
  const navigate  = useNavigate();

  const modifiedAt = timezones(row.modifiedAt, 'YYYY-MM-DD HH:mm:ss');
  const createdAt = timezones(row.createdAt, 'YYYY-MM-DD HH:mm:ss');

  const [ visible, setVisible ] = useState(false);
  
  return (
    <tr>
      <td>{ row.category }</td>
      <td>{ row.waterTemperature }</td>
      <td>{ row.waterTemperatureUnit }</td>
      <td>{ modifiedAt }</td>
      <td>{ createdAt }</td>
      <td>
        <MoreButton id={`more${row.displayNameId}`} className='more' onClick={() => setVisible(true)} />
        <Popover
          target={`#more${row.displayNameId}`}
          visible={visible}
          hideOnOutsideClick={true}
          onHiding={() => setVisible(false)}
          position='left'
        >
          <button onClick={() => navigate('update', {state: row})}>
            수정
          </button>

          <button
            onClick={() => {
              setVisible(false);
              setDialog(row.displayNameId);
            }}
          >
            삭제
          </button>
        </Popover>
      </td>
    </tr>
  );
}